export { GeneralJournalModel } from './GeneralJournal.model';
export { GeneralJournalDetailModel } from './GeneralJournalDetail.model';
export { EducationPopupModel } from './EducationPopup.model';
